
const ArrowSelect = () => {
  return <div className="blink">></div>
}

export default ArrowSelect